<button (click)="handleBackToTopClick()" class="eb-back-to-top-button">
  <em class="fas fa-chevron-up"></em>
</button>
